import exifr from 'exifr'

export async function extractGpsFromFile(file) {
  try {
    const gps = await exifr.gps(file)
    if (gps?.latitude == null || gps?.longitude == null) return null

    return {
      lat: gps.latitude,
      lng: gps.longitude,
    }
  } catch {
    return null
  }
}
